import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import Modal from 'components/Modal'
import { Button, type ButtonStyles } from '@nexiahome/ui-common/components/primitives/buttons'

import useDealer from 'hooks/useDealer'

import { color } from 'styles/colors'
import { StackedButtonContainer, screenSize } from 'styles/shared'

type Props = {
  closeCallback: (reloadPage: boolean) => void
}

const HEHMModal = ({ closeCallback }: Props) => {
  const navigate = useNavigate()
  const { dealer, isDealerLoaded } = useDealer()
  const imageUrl = (dealer as { imageUrl?: string | null }).imageUrl ?? null

  const onClickClose = () => {
    closeCallback(false)
  }

  const onDealerLogoPress = () => {
    closeCallback(false)
    navigate('/dealer_image')
  }

  let uploadText = 'Upload Dealer Logo'

  if (isDealerLoaded) {
    if (imageUrl !== null) {
      uploadText = 'Update Dealer Logo'
    }
  } else {
    return
  }

  return (
    <S.Modal variant="sm" isDisplayed closeCallback={() => closeCallback(false)}>
      <S.Content>
        <S.Top>
          <S.ProductLogo src="/img/pmk-logo.png" alt="PMK logo" />
          <div />
        </S.Top>

        <S.Success>
          Success!
        </S.Success>
        <p>Everyone on your account with Partners credentials and Technician App access can now install and provision HVAC Performance Monitoring Kits.</p>

        <S.StackedButtonContainer noBorder>
          <Button
            decoration="secondary"
            text="OK"
            styles={closeButtonStyle}
            onPress={onClickClose}
          />
          <Button
            decoration="positive"
            text={uploadText}
            styles={uploadButtonStyle}
            onPress={onDealerLogoPress}
          />
        </S.StackedButtonContainer>
      </S.Content>
    </S.Modal>
  )
}

export default HEHMModal

const buttonFontSize = 14
const buttonHeight = 44
const closeButtonStyle: ButtonStyles = {
  button: {
    borderWidth: 0,
    height: buttonHeight
  },
  text: {
    fontSize: buttonFontSize,
    textTransform: 'none'
  }
}

const uploadButtonStyle: ButtonStyles = {
  button: {
    marginLeft: 15,
    height: buttonHeight
  },
  text: {
    fontSize: buttonFontSize,
    textTransform: 'none'
  }
}

const S = {
  Modal: styled(Modal)`
    height: 100%;
  `,
  Content: styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
  `,
  Explanation: styled.li`
    margin: 10px 0 0 0;
    padding-right: 5px;
    padding-left: 5px;
  `,
  ProductLogo: styled.img`
    height: 50px;
    margin-bottom: 25px;
    @media ${screenSize.small} {
      max-width: 290px;
    }
  `,
  Success: styled.div`
    font-size: 18px;
    font-weight: bold;
    color: ${color('hehmModalSuccessText')};
    text-transform: none;
  `,
  Top: styled.div`
    display: flex;
    justify-content: center;
    padding-top: 10px;
  `,
  StackedButtonContainer: styled(StackedButtonContainer)`
    margin-top: auto;
  `
}
